import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    ColorSwatchPickerAddStyleConstantType,
    ColorSwatchPickerDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../types";
import {
    COLOR_SWATCH_DISABLED_OPACITY
} from "../colorSwatch/stylesheet";
import {
    getFocusRingStyle
} from "../../helpers/theme/state";
import {
    webStyle
} from "../../utils";

export const getColorSwatchPickerAddStyle = ({
    isFocusVisible,
    isDisabled,
    swatchSize,
    radiuses,
    borders,
    colors
}: ColorSwatchPickerAddStyleConstantType): ViewStyle => {
    return {
        ...getFocusRingStyle({
            colorKey: "default",
            isFocusVisible,
            borders,
            colors
        }),
        opacity: isDisabled ? COLOR_SWATCH_DISABLED_OPACITY : 1,
        borderColor: colors.content.icon.low,
        borderRadius: radiuses.full,
        borderWidth: borders.line,
        height: swatchSize,
        width: swatchSize
    };
};

export const useStyles = ({
    swatchSize,
    columns,
    layout,
    spaces
}: ColorSwatchPickerDynamicStyleType) => {
    const container = {
        gap: spaces.spacingSm,
        ...layout === "grid" ? {
            width: columns * swatchSize + (columns - 1) * spaces.spacingSm
        } : {}
    } as Mutable<ViewStyle>;

    return {
        container
    };
};

const stylesheet = StyleSheet.create({
    add: {
        justifyContent: "center",
        borderStyle: "dashed",
        alignItems: "center",
        ...webStyle({
            outlineStyle: "solid",
            outlineWidth: 0
        })
    },
    container: {
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap"
    }
});

export default stylesheet;
